<div *ngIf="!firstLoad" class="audit-tab-body">
  <!-- <div class="seo-ai_analysis-detailed-search">
    <h2 class="seo-ai_analysis-design-v2-headline">
      How <b>{{ selectedProject?.domain }}</b> is performing
    </h2>
  </div> -->
  <div class="seo-ai_analysis-design-v2">
    <!-- ── SERP Performance: the overall score, then the detailed strength
         rings — one container so the hierarchy reads overall → detail -->
    <div
      class="seo-bw-card"
      *ngIf="serpData || siteStrengthOverviewData?.length"
    >
      <h3 class="seo-bw-title">🔍 SERP Performance</h3>

      <!-- Overall score, centred above the breakdown it feeds -->
      <div class="seo-overall-wrap">
        <div class="seo-overall" *ngIf="serpData">
          <div class="seo-serp-main">
            <audit-ring
              [value]="serpData.score"
              [color]="serpData.scoreColor"
              [size]="96"
              [stroke]="9"
              [fontSize]="24"
              [label]="serpData.score"
            ></audit-ring>
            <div class="seo-serp-info">
              <div class="seo-serp-desc">{{ serpData.description }}</div>
              <div
                class="seo-serp-vs"
                *ngIf="serpData.hasComp"
                [style.color]="serpData.vsColor"
              >
                {{ serpData.compName }} sits at {{ serpData.comp }}/100
              </div>
            </div>
          </div>

          <div class="seo-serp-bars">
            <div class="seo-serp-bar-row" *ngFor="let c of serpData.bars">
              <span class="seo-serp-bar-label">{{ c.name }}</span>
              <ng-container *ngIf="c.crawled; else serpUncrawled">
                <div class="seo-serp-bar-track">
                  <div
                    class="seo-serp-bar-fill"
                    [style.width.%]="c.score"
                    [style.background]="c.color"
                  ></div>
                </div>
                <span
                  class="seo-serp-bar-val"
                  [class.seo-serp-bar-val--muted]="!c.isYou"
                  >{{ c.score
                  }}<small class="seo-serp-bar-val-max">/100</small></span
                >
              </ng-container>
              <ng-template #serpUncrawled>
                <span class="seo-serp-bar-uncrawled">couldn't be crawled</span>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <!-- SEO score over time (illustrative until history exists) -->
      <!-- <div class="seo-bw-card seo-trend-card">
        <div class="seo-bw-card-head">
          <h3 class="seo-bw-title" style="margin: 0">SEO score over time</h3>
          <span class="seo-bw-legend">
            <span class="seo-bw-lg"
              ><i class="seo-bw-lg-dot" [style.background]="bwAccent"></i
              >You</span
            >
            <span class="seo-bw-lg" *ngIf="serpData.hasComp"
              ><i class="seo-bw-lg-dot" [style.background]="bwComp"></i
              >{{ serpData.compName }}</span
            >
          </span>
        </div>
        <audit-trend
          [labels]="seoTrendLabels"
          [series]="seoTrendSeries"
          [max]="100"
          [viewHeight]="230"
        ></audit-trend>
      </div> -->

      <!-- Detail -->
      <ng-container *ngIf="siteStrengthOverviewData?.length">
        <!-- Current flowing from the overall score down into the three metrics
             it breaks down into. Decorative only. -->
        <div
          class="seo-connector"
          *ngIf="serpData && siteStrengthOverviewData.length === 3"
        >
          <!-- Three separate paths — no shared stem. They leave the score card
               30 units apart (≈30px at a 1200px-wide container, since the
               viewBox maps 1:1 there), drop, turn a right angle out to their
               column, then drop into the card; the corners carry a small radius
               so the turn stays smooth. pathLength normalises all three to 100
               so a single dash animation reaches every card at the same moment. -->
          <svg
            class="seo-conn-svg"
            viewBox="0 0 1200 30"
            aria-hidden="true"
            focusable="false"
          >
            <g class="seo-conn-track">
              <path d="M570 0 V9 Q570 16 563 16 H207 Q200 16 200 23 V30"></path>
              <path d="M600 0 V30"></path>
              <path
                d="M630 0 V9 Q630 16 637 16 H993 Q1000 16 1000 23 V30"
              ></path>
            </g>
            <g class="seo-conn-spark">
              <path
                [attr.pathLength]="100"
                d="M570 0 V9 Q570 16 563 16 H207 Q200 16 200 23 V30"
              ></path>
              <path [attr.pathLength]="100" d="M600 0 V30"></path>
              <path
                [attr.pathLength]="100"
                d="M630 0 V9 Q630 16 637 16 H993 Q1000 16 1000 23 V30"
              ></path>
            </g>
          </svg>
        </div>
        <div class="seo-bw-strength-grid">
          <div
            class="seo-bw-strength"
            *ngFor="let s of siteStrengthOverviewData"
          >
            <audit-ring
              [value]="s.value"
              [color]="bwColor(s.value)"
              [size]="112"
              [stroke]="9"
              [fontSize]="24"
              [label]="(s.value || 0) + '%'"
            ></audit-ring>
            <div class="seo-bw-strength-label">{{ s.title }}</div>
            <div class="seo-bw-strength-note">{{ s.description }}</div>
            <div
              class="seo-bw-strength-vs"
              *ngIf="
                s.competitorValue !== null && s.competitorValue !== undefined
              "
            >
              vs {{ seoCompDomain }}
              <b
                [style.color]="
                  s.value >= s.competitorValue ? bwColor(90) : bwColor(30)
                "
              >
                {{ s.competitorValue }}%
              </b>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div
      class="seo-bw-two"
      *ngIf="content_score_fixes?.length > 0 || quick_wins_array?.length > 0"
    >
      <div class="seo-bw-card" *ngIf="content_score_fixes?.length > 0">
        <div class="seo-bw-card-head">
          <h3 class="seo-bw-title">Observed issues</h3>
          <div class="seo-bw-tabs">
            <button
              class="seo-bw-tab"
              *ngFor="let item of horizontalOptionsCategory"
              [class.active]="selected_category === item.value"
              (click)="clickCategory(item.value)"
            >
              {{ item.viewValue }}
            </button>
          </div>
        </div>
        <div class="seo-bw-issues">
          <div class="seo-bw-issue" *ngFor="let fix of content_score_fixes">
            <span class="seo-bw-issue-dot">!</span>
            <div class="seo-bw-issue-body">
              <div class="seo-bw-issue-title">{{ fix.name_formatted }}</div>
              <div class="seo-bw-issue-desc">
                {{ fix.description_formatted }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="seo-bw-card" *ngIf="quick_wins_array?.length > 0">
        <h3 class="seo-bw-title">Quick wins</h3>
        <div class="seo-bw-issues">
          <div class="seo-bw-issue" *ngFor="let win of quick_wins_array">
            <span class="seo-bw-issue-dot seo-bw-issue-dot--good">✓</span>
            <div class="seo-bw-issue-body">
              <div class="seo-bw-issue-title">{{ win.quick_win_title }}</div>
              <div class="seo-bw-issue-desc">
                {{ win.quick_win_description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="seo-bw-two"
      *ngIf="page_bins?.length > 0 || backlink_bins?.length > 0"
    >
      <div class="seo-bw-card" *ngIf="page_bins?.length > 0">
        <div class="seo-bw-card-head">
          <h3 class="seo-bw-title">Content score distribution</h3>
          <span class="seo-bw-legend" *ngIf="contentHasCompetitor">
            <span class="seo-bw-lg"
              ><i class="seo-bw-lg-dot" [style.background]="bwAccent"></i
              >You</span
            >
            <span class="seo-bw-lg"
              ><i class="seo-bw-lg-dot" [style.background]="bwComp"></i
              >{{ contentCompName }}</span
            >
          </span>
        </div>
        <div class="seo-bw-dist">
          <div class="seo-bw-dist-row" *ngFor="let bin of page_bins">
            <span class="seo-bw-dist-label">{{ bin.name }}</span>
            <div class="seo-bw-dist-bars">
              <div
                class="seo-bw-dist-bar"
                [style.width.%]="bin.your_percentage"
                [style.background]="bwAccent"
              ></div>
              <div
                class="seo-bw-dist-bar"
                *ngIf="contentHasCompetitor"
                [style.width.%]="bin.competitor_percentage"
                [style.background]="bwComp"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="seo-bw-card" *ngIf="backlink_bins?.length > 0">
        <div class="seo-bw-card-head">
          <h3 class="seo-bw-title">Backlink profile</h3>
          <span class="seo-bw-legend" *ngIf="backlinkHasCompetitor">
            <span class="seo-bw-lg"
              ><i class="seo-bw-lg-dot" [style.background]="bwAccent"></i
              >You</span
            >
            <span class="seo-bw-lg"
              ><i class="seo-bw-lg-dot" [style.background]="bwComp"></i
              >{{ backlinkCompName }}</span
            >
          </span>
        </div>
        <div class="seo-bw-dist">
          <div class="seo-bw-dist-row" *ngFor="let bin of backlink_bins">
            <span class="seo-bw-dist-label">{{ bin.name }}</span>
            <div class="seo-bw-dist-bars">
              <div
                class="seo-bw-dist-bar"
                [style.width.%]="bin.percentage"
                [style.background]="bwAccent"
              ></div>
              <div
                class="seo-bw-dist-bar"
                *ngIf="backlinkHasCompetitor"
                [style.width.%]="bin.competitor_percentage"
                [style.background]="bwComp"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="showCustomChart">
    <div class="design-v2-flex">
      <div class="design-v2-flex-item">
        <div
          class="design-v2-flex-item-container"
          style="margin-top: 5px; display: block"
        >
          <app-custom-barchart
            [isViewAllActiveProject]="false"
            [barchartInputData]="barChartOutputData"
            (barchartClicked)="barchartClicked($event)"
            (competitorUrlChanged)="competitorUrlChanged($event)"
            (factorChange)="factorChange($event)"
            [cardName]="cardName"
            [keywordData]="keywordDataInsights"
            [selectedCard]="selectedCard"
            [isFreemiumUser]="false"
            (constructFixes)="constructFixes($event)"
          ></app-custom-barchart>
        </div>
      </div>
    </div>
  </ng-container>

  <div
    class="ai_analysis_gr_container ai_analysis_overview_scroll"
    *ngIf="showBacklinkOnlyTable"
  >
    <div class="design-v2-flex" style="width: 100%; margin: 0">
      <div class="design-v2-flex-item">
        <div class="design-v2-flex-item-container" style="margin: 0">
          <div
            class="seo-ai_analysis-backlinks-table_container"
            style="margin-top: 0; padding-top: 0; width: 100%"
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 15px;
              "
            >
              <div>
                <h2>
                  {{ "words.samples" | translate }}:
                  <span style="opacity: 0.6">
                    {{ renamedVariables?.[backLinkselectedVariable]?.name }}
                  </span>
                </h2>
              </div>
              <div
                class="position_tracking_header-filters"
                *ngIf="competitorExists"
              >
                <div class="custom_horizontal_option_select-container">
                  <div
                    class="custom_horizontal_option_active"
                    [ngStyle]="{
                      width: horizontalSingleOptionStyles.width,
                      transform: horizontalSingleOptionStyles.transform,
                    }"
                  ></div>
                  <div
                    class="custom_horizontal_option_select"
                    *ngFor="let item of horizontalSingleSelectOptions"
                    (click)="
                      onToggleChange($event, item, horizontalSingleOptionStyles)
                    "
                  >
                    <p>
                      {{ "words." + item.value | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="hover-unhide">
              <div class="custom_table-container" style="margin-top: 10px">
                <table class="custom_table">
                  <thead>
                    <tr>
                      <th style="width: 200px" *ngIf="isViewAllActiveProject">
                        <div>
                          {{ "words.domain" | translate }}
                        </div>
                      </th>
                      <th class="maxWidth300">
                        <div *ngIf="tableVarianleOne">
                          {{ tableVarianleOne }}
                        </div>
                      </th>
                      <th>
                        <div *ngIf="tableVarianleTwo">
                          {{ tableVarianleTwo }}
                        </div>
                      </th>
                      <th style="width: 160px" *ngIf="show_ai_score_column">
                        <div>
                          {{ "words.ranking_impact" | translate }}
                          <svg
                            (click)="sortByRankingImpact()"
                            class="custom_table_sort-icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            [ngClass]="{
                              active: sortByRankingImpactTrigger,
                            }"
                          >
                            <g clip-path="url(#clip0_1676_4762)">
                              <path
                                d="M12 8V15"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M16 12L12 8"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8 12L12 8"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1676_4762">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </th>
                      <th style="width: 160px">
                        <div
                          matTooltip="{{
                            'phrases.a_measure_of_how_closely_your_content_matches_the_users_search_intent_and_query'
                              | translate
                          }}"
                          matTooltipPosition="above"
                        >
                          {{ "words.relevance_score" | translate }}
                          <svg
                            (click)="sortByRelevancyScore()"
                            class="custom_table_sort-icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            [ngClass]="{
                              active: !sortByRelevancyScoreTrigger,
                            }"
                          >
                            <g clip-path="url(#clip0_1676_4762)">
                              <path
                                d="M12 8V15"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M16 12L12 8"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8 12L12 8"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1676_4762">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </th>
                      <th
                        style="width: 100px"
                        *ngIf="backlinkRelevanceTableActive"
                      >
                        <div>
                          {{ "words.backlink_url" | translate }}
                        </div>
                      </th>
                      <th style="width: 70px">
                        <div>{{ "words.url" | translate }}</div>
                      </th>

                      <th
                        style="width: 200px"
                        *ngIf="selectedFilterButton != 'competitor'"
                      >
                        <div>
                          <p style="visibility: hidden; margin: 0">
                            {{ "words.actions" | translate }}
                          </p>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container
                      *ngIf="
                        backlinkOnlyTableData &&
                          backlinkOnlyTableData.length > 0;
                        else noTableData
                      "
                    >
                      <tr *ngFor="let item of backlinkOnlyTableData">
                        <td *ngIf="isViewAllActiveProject">
                          {{ item["domain"] }}
                        </td>
                        <td class="maxWidth300 cursor_pointer">
                          <ng-container *ngIf="!item.showMore">
                            <p
                              class="long-title"
                              matTooltip="{{ item['show_var1_text'] }}"
                              matTooltipPosition="above"
                              style="margin: 0"
                            >
                              {{ item["show_var1_text"] }}
                            </p>
                          </ng-container>
                          <ng-container *ngIf="item.showMore">
                            <p
                              class="long-title"
                              matTooltip="{{ item['var1_text'] }}"
                              matTooltipPosition="above"
                              style="margin: 0"
                            >
                              {{ item["var1_text"] }}
                            </p>
                          </ng-container>
                        </td>
                        <td
                          style="font-size: 0.8em"
                          class="maxWidth300 cursor_pointer"
                        >
                          <ng-container *ngIf="!item.showMore2">
                            <p
                              class="long-title"
                              matTooltip="{{ item['show_var2_text'] }}"
                              matTooltipPosition="above"
                              style="margin: 0"
                            >
                              {{ item["show_var2_text"] }}
                            </p>
                          </ng-container>
                          <ng-container *ngIf="item.showMore2">
                            <p
                              class="long-title"
                              matTooltip="{{ item['var2_text'] }}"
                              matTooltipPosition="above"
                              style="margin: 0"
                            >
                              {{ item["var2_text"] }}
                            </p>
                          </ng-container>
                        </td>
                        <td
                          *ngIf="show_ai_score_column"
                          style="font-size: 0.8em"
                          class="table_ai_score_value"
                          [class.low_value]="item.AI_score < 70"
                          [class.mid_value]="
                            item.AI_score >= 70 && item.AI_score < 85
                          "
                          [class.high_value]="item.AI_score >= 85"
                        >
                          {{ item["AI_score"]
                          }}<span
                            style="
                              color: var(--text-main-color);
                              opacity: 0.5;
                              font-size: 8px;
                            "
                            >/100</span
                          >
                        </td>
                        <td style="font-size: 0.8em">
                          {{
                            formatPercentage(
                              item[this.backLinkselectedVariable] || 0
                            )
                          }}
                        </td>
                        <td
                          *ngIf="backlinkRelevanceTableActive"
                          style="cursor: pointer"
                          (click)="openInNewTab(item.var2_linkfull, item)"
                          [matTooltip]="item.var2_linkfull"
                          matTooltipPosition="above"
                        >
                          <svg
                            viewBox="0 0 640 512"
                            style="
                              min-width: 16px;
                              width: 16px;
                              fill: var(--navmenu-icon-svg-color);
                            "
                          >
                            <path
                              d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                            />
                          </svg>
                        </td>
                        <td
                          style="cursor: pointer"
                          (click)="openInNewTab(item.var1_link, item)"
                          [matTooltip]="item.var1_link"
                          matTooltipPosition="above"
                        >
                          <svg
                            viewBox="0 0 640 512"
                            style="
                              min-width: 16px;
                              width: 16px;
                              fill: var(--navmenu-icon-svg-color);
                            "
                          >
                            <path
                              d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                            />
                          </svg>
                        </td>

                        <td
                          style="text-align: right"
                          *ngIf="selectedFilterButton != 'competitor'"
                        >
                          <div style="display: flex; align-items: center">
                            <!-- <p
                                        (click)="viewMore(item)"
                                        style="
                                          color: var(
                                            --accent-theme-color2
                                          ) !important;
                                          margin: 0;
                                          cursor: pointer;
                                          text-align: right;
                                          font-size: 0.9em;
                                          display: inline-block;
                                          white-space: nowrap;
                                        "
                                      >
                                        {{ "words.view_more" | translate }}
                                      </p> -->
                            <button
                              mat-raised-button
                              type="button"
                              class="btn_withoutIcon custom-button"
                              (click)="openAiEditor(item)"
                              style="
                                margin: 0 0 0 auto;
                                border: none !important;
                                background: transparent !important;
                                display: inline-block;
                              "
                            >
                              <span
                                style="
                                  margin-right: 0px;
                                  top: 1px;
                                  position: relative;
                                  white-space: nowrap;
                                "
                              >
                                {{ "words.ai_editor" | translate }}
                              </span>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                    <ng-template #noTableData>
                      <tr>
                        <td colspan="10">
                          {{ "phrases.no_data_found" | translate }}
                        </td>
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
              </div>
              <div class="general-hide-scrollbar"></div>
              <!-- Loader Overlay -->
              <div
                class="loading-bug-data-overlay"
                *ngIf="isLoadingBacklinkTable"
              >
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            </div>
            <ng-container *ngIf="backlinkTotalCount > 10">
              <div class="paginator_with_pageOptions_container">
                <mat-form-field
                  class="bhm-option-container-1"
                  style="
                    --label-name: &quot;&quot;;
                    --form-field-infix-width: 150px;
                  "
                >
                  <mat-select
                    [(ngModel)]="pageSize"
                    (selectionChange)="onPageChange2($event)"
                  >
                    <mat-option
                      class="bhm-option-select-option-1"
                      *ngFor="let size of pageSizeOptions"
                      [value]="size"
                    >
                      {{ size }}
                      {{ "phrases.results_per_page" | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-paginator
                  [pageSize]="pageSize"
                  [pageSizeOptions]="pageSizeOptions"
                  [length]="dataSource.data.length"
                  (page)="onPageChange($event)"
                  [pageIndex]="pageIndex"
                ></mat-paginator>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ai_analysis_gr_container" *ngIf="showInternalLinkOnlyTable">
    <div
      class="seo-ai_analysis-backlinks-table_container"
      style="
        margin-top: 20px;
        border-top: 1px solid var(--border-color-theme);
        padding-top: 20px;
        width: 100%;
      "
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 15px;
        "
      >
        <div>
          <h2 style="margin: 0; font-size: 19px; font-weight: 400">
            {{ "words.samples" | translate }}:
            <span style="opacity: 0.6">
              {{ renamedVariables?.[backLinkselectedVariable]?.name }}
            </span>
          </h2>
        </div>
        <div class="position_tracking_header-filters">
          <div class="custom_horizontal_option_select-container">
            <div
              class="custom_horizontal_option_active"
              [ngStyle]="{
                width: horizontalSingleOptionStyles.width,
                transform: horizontalSingleOptionStyles.transform,
              }"
            ></div>
            <div
              class="custom_horizontal_option_select"
              *ngFor="let item of horizontalSingleSelectOptions"
              (click)="
                onToggleChange($event, item, horizontalSingleOptionStyles)
              "
            >
              <p>
                {{ "words." + item.value | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="hover-unhide">
        <div class="custom_table-container" style="margin-top: 10px">
          <table class="custom_table">
            <thead>
              <tr>
                <th style="width: 200px" *ngIf="isViewAllActiveProject">
                  <div>{{ "words.domain" | translate }}</div>
                </th>
                <th class="maxWidth300">
                  <div>{{ "words.page_title" | translate }}</div>
                </th>
                <th style="width: 160px">
                  <div *ngIf="this.backLinkselectedVariable == 'distance'">
                    {{ "words.distance" | translate }}
                    <svg
                      (click)="sortByDistance()"
                      class="custom_table_sort-icon"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      [ngClass]="{
                        active: !sortByDistanceTrigger,
                      }"
                    >
                      <g clip-path="url(#clip0_1676_4762)">
                        <path
                          d="M12 8V15"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16 12L12 8"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 12L12 8"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1676_4762">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div *ngIf="this.backLinkselectedVariable == 'pr'">
                    {{ "words.page_rank" | translate }}
                    <svg
                      (click)="sortByPageRank()"
                      class="custom_table_sort-icon"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      [ngClass]="{
                        active: !sortByPageRankTrigger,
                      }"
                    >
                      <g clip-path="url(#clip0_1676_4762)">
                        <path
                          d="M12 8V15"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16 12L12 8"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 12L12 8"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1676_4762">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </th>
                <th style="width: 100px">
                  <div>{{ "words.url" | translate }}</div>
                </th>
                <th
                  style="width: 200px"
                  *ngIf="selectedFilterButton != 'competitor'"
                >
                  <div>
                    <p style="visibility: hidden; margin: 0">
                      {{ "words.actions" | translate }}
                    </p>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngIf="internalLinkingDataTable.length > 0; else noTableData"
              >
                <tr *ngFor="let item of internalLinkingDataTable">
                  <td *ngIf="isViewAllActiveProject">
                    {{ item["domain"] }}
                  </td>
                  <td class="maxWidth300 cursor_pointer">
                    <div
                      [matTooltip]="item.title"
                      *ngIf="item.distance != 0"
                      class="long-title"
                    >
                      {{ item["show_title"] }}
                    </div>
                    <div *ngIf="item.distance === 0">/</div>
                  </td>
                  <td>
                    <ng-container
                      *ngIf="this.backLinkselectedVariable == 'distance'"
                    >
                      {{ item["distance"] }}
                    </ng-container>
                    <ng-container *ngIf="this.backLinkselectedVariable == 'pr'">
                      {{ formatPageRank(item["page_rank"]) }}
                    </ng-container>
                  </td>
                  <td
                    style="cursor: pointer"
                    (click)="openInNewTab(item.url, item)"
                    [matTooltip]="item.url"
                    matTooltipPosition="above"
                  >
                    <svg
                      viewBox="0 0 640 512"
                      style="
                        min-width: 16px;
                        width: 16px;
                        fill: var(--navmenu-icon-svg-color);
                      "
                    >
                      <path
                        d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                      />
                    </svg>
                  </td>
                  <td style="text-align: right">
                    <!-- <p
                                  (click)="viewMore(item)"
                                  style="
                                    color: var(
                                      --accent-theme-color2
                                    ) !important;
                                    margin: 0;
                                    cursor: pointer;
                                    text-align: right;
                                    font-size: 0.9em;
                                    display: inline-block;
                                  "
                                >
                                  View more
                                </p> -->
                    <button
                      mat-raised-button
                      type="button"
                      class="btn_withoutIcon custom-button"
                      (click)="openAiEditor(item)"
                      style="
                        margin: 0 auto;
                        border: none !important;
                        background: transparent !important;
                        display: inline-block;
                        margin-left: 14px;
                      "
                    >
                      <span
                        style="margin-right: 0px; top: 1px; position: relative"
                      >
                        {{ "words.fix_it_here" | translate }}
                      </span>
                    </button>
                  </td>
                </tr>
              </ng-container>
              <ng-template #noTableData>
                <tr>
                  <td colspan="10">
                    {{ "phrases.no_data_found" | translate }}
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="general-hide-scrollbar"></div>
        <!-- Loader Overlay -->
        <div class="loading-bug-data-overlay" *ngIf="isLoadingBacklinkTable">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
      <ng-container *ngIf="internalTotalCount > 10">
        <div class="paginator_with_pageOptions_container">
          <mat-form-field
            class="bhm-option-container-1"
            style="--label-name: &quot;&quot;; --form-field-infix-width: 150px"
          >
            <mat-select
              [(ngModel)]="pageSize"
              (selectionChange)="onPageChange2($event)"
            >
              <mat-option
                class="bhm-option-select-option-1"
                *ngFor="let size of pageSizeOptions"
                [value]="size"
              >
                {{ size }}
                {{ "phrases.results_per_page" | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-paginator
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [length]="dataSource.data.length"
            (page)="onPageChange($event)"
            [pageIndex]="pageIndex"
          ></mat-paginator>
        </div>
      </ng-container>
    </div>
  </div>

  <div
    class="loading-data-overlay"
    *ngIf="isLoadingBacklinkTable || showLoader"
  >
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <!-- Competitor switch overlay -->
  <div class="loading-data-overlay" *ngIf="competitorSwitching$ | async">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<div *ngIf="firstLoad">
  <div style="display: flex; gap: 40px">
    <div class="bar-chart-box" style="width: 100%" fxLayout="column">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '180px',
          outline: 'none',
          'background-color': '#37474f1a',
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
  <div class="bar-chart-box" style="margin-top: 30px" fxLayout="column">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '220px',
        outline: 'none',
        'background-color': '#37474f1a',
      }"
    ></ngx-skeleton-loader>
  </div>
</div>
